import * as React from 'react';
import { gold} from '../../../../getLPTheme';
import 'react-multi-carousel/lib/styles.css';
import {Stack} from "@mui/material";
import Container from '@mui/material/Container';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button } from "@mui/material";
import ShopCardsSearch from './hotelCardSearch'
import Carousel from './shopCarousel'

// Genero una base de datos de Marcas Ficticias
function createMarcaCard(
  id: number,
  img: string,
  title: string,
  description: string,
  link: string,
) {
  return { id, img, title, description, link};
}

const MarcasCards = [
  createMarcaCard(
    1,
    'https://http2.mlstatic.com/storage/mshops-appearance-api/images/35/59175635/logo-2021061513030498800.png',
    'Riera Golf',
    'Contenido - Tienda de palos y sets, bolsas, pelotas, indumentaria, carros manuales, carros electricos y mas! Descuentos de hasta 20% off',
    'https://www.rieragolf.com.ar/nuestros-productos/?gad_source=1&gclid=CjwKCAjw9cCyBhBzEiwAJTUWNUvfXaA4M8g8M1LMghDnY9AJex0m2VIp3GVj21_e0DTu4GaWTB9pDRoCkK8QAvD_BwE'
  ),
  createMarcaCard(
    2,
    'https://http2.mlstatic.com/storage/mshops-appearance-api/images/63/10260063/logo-2024031914385469542.png',
    'Kaddy Golf',
    'Contenido - Tienda de palos y sets, bolsas, pelotas, indumentaria, carros manuales, carros electricos y mas! Descuentos de hasta 20% off',
    'https://www.kaddygolf.com.ar/?gad_source=1&gclid=CjwKCAjw9cCyBhBzEiwAJTUWNSfWMYPtEWq1NPNImZ-9HvVxODwCgRSwEzOxnj0RvygluwvI7_jdeBoCqtAQAvD_BwE'
  ),
  createMarcaCard(
    3,
    'https://www.buengolpe.com/media/aw_sbb/gold/AXGLO-LOGO.png',
    'Buen Golpe',
    'Axglo. Golf | Ya puedes comprar en Buengolpe.com los nuevos carros de golf Axglo y una amplia gama de accesorios para estos carrros de golf | La marca, gracias a los comentarios constantes de los clientes y usuarios finales, se propuso el reto de crear un carro de golf de tres ruedas.',
    'https://www.buengolpe.com/manufacturer/axglo-golf.html'
  ),
  createMarcaCard(
    4,
    'https://ams3.digitaloceanspaces.com/graffica/2022/12/Three-Bars-adidas-logo-1.jpg-1024x570.webp',
    'Adidas',
    'Adidas es mucho más que ropa deportiva y ropa de entrenamiento. Nos asociamos con los mejores de la industria para co-crear. De esta manera, ofrecemos a nuestras seguidores la ropa deportiva y los estilos que mejor se adaptan a sus necesidades deportivas, sin dejar de lado la sostenibilidad. Apoyamos a los creadores Mejorar su juego. Creamos el cambio. Y pensamos en el impacto que tenemos en nuestro mundo.',
    'https://www.adidas.com.ar/'
  ),
  createMarcaCard(
    5,
    'https://www.pixartprinting.it/blog/wp-content/uploads/2023/12/1978-1024x561.jpg',
    'Nike',
    'Descubrí lo que te mueve',
    'https://www.nike.com.ar/?gad_source=1&gclid=CjwKCAjw9cCyBhBzEiwAJTUWNaJlnTpsCUHyot78pS6thvHDffRge2unLiTuQAoZcCRgRORZlPqUGRoCTKoQAvD_BwE'
  ),
];



//-------------------- Funcion principal exportada --------------------


export default function GestionarMarcas () {

  return (
    <Box>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 5, sm: 5 },
        }}
      >
        <Stack spacing={2} useFlexGap sx={{ width: { xs: '100%', sm: '70%' } }}>
          <Box sx={{ width:"100%", display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
            <Box  sx={{ width:{xs:"80%", sm:"50%", md:"50%"}, display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
              <ShopCardsSearch/>
              <Button sx={{m:1, color: "white", backgroundColor: gold[500], height:55, width: "auto"}} type='submit' color='primary' variant="contained"  ><SearchIcon/></Button>
            </Box>
          </Box>
          <Box sx={{display: 'flex',flexDirection: 'column',alignSelf: 'center',textAlign: 'center',}}>
            <Carousel marcasCards={MarcasCards} showButtons/>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}